module.exports = __webpack_public_path__ + "static/media/moveTable.a93e9eff.png";